<template>
    <div class="report" v-if="Object.keys(this.reportDetails).length !== 0">
        <!-- Basic info -->
        <div class="col-sm-12 editor-form nopads nopads p-2 pb-4 w-100">
            <div class="row">
                <div class="col-sm-12 nopads">
                    <div class="row">
                        <span class="span-header">
                            {{ $t('mvr_inspection.inspection_report_details.report_title') }}
                        </span>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 nopads">
                            <span class="item-detail-title px-2">{{ $t('mvr_inspection.inspection_report_details.date')
                                }}</span>
                        </div>
                        <span class="span-title">{{ getDate(reportDetails.created, true) }}</span>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 nopads">
                            <span class="item-detail-title px-2">{{ $t('mvr_inspection.inspection_report_details.inspector')
                                }}</span>
                        </div>
                        <span class="span-title">{{ getInspector(reportDetails.inspector) }}</span>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 nopads">
                            <span class="item-detail-title px-2">{{ $t('mvr_inspection.inspection_report_details.contract')
                                }}</span>
                        </div>
                        <span class="span-title">{{ reportDetails.contract.name }}</span>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 nopads">
                            <span class="item-detail-title px-2">{{ $t('mvr_inspection.inspection_report_details.order')
                                }}</span>
                        </div>
                        <span class="span-title">{{ reportDetails.order ? reportDetails.order.task_type.name : "-"
                        }}</span>
                    </div>
                    <div class="row nopads mt-2">
                        <div class="col-sm-12 nopads">
                            <span class="item-detail-title px-2">{{ $t('mvr_inspection.inspection_report_details.site_notes')
                                }}</span>
                        </div>
                        <span class="span-title">{{ reportDetails.site || "-" }}</span>
                    </div>
                </div>
            </div>
            <div class="col-12 stat-container ml-0 mr-3 mt-4 pt-3 pb-3 px-3">
                <div class="row">
                    <div class="col-sm-6 stat-header" style="color: #404041 !important;">{{ $t('mvr_inspection.inspection_report_details.total_pass') }} </div>
                    <div class="col-sm-6 stat-header" style="color: #404041 !important;">{{ getTotal().total_pass }} </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 stat-header" style="color: #404041 !important;">{{ $t('mvr_inspection.inspection_report_details.total_fail')}} </div>
                    <div class="col-sm-6 stat-header" style="color: #404041 !important;">{{ getTotal().total_fails}} </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 stat-header" style="font-weight: 600">{{ $t('mvr_inspection.inspection_report_details.result') }} </div>
                    <div class="col-sm-6 stat-header" style="font-weight: 600">{{ getTotal().total_percentage}} </div>
                </div>
            </div>
            <div class="row mt-4">
                <span class="span-header">
                    {{ $t('mvr_inspection.inspection_report_details.measurement_results') }}
                </span>
            </div>
            <div class="row mt-4" v-for="(section, index) in getGroupedSections()"
                v-bind:key="`${section.section_group}-${index}`">
                <div class="col-sm-12 nopads">
                    <span class="item-detail-title px-2">{{ section.section_header }}</span>
                </div>
                <div class="col-sm-12">

                    <vue3-datatable
                        ref="resultTable"
                        :rows="section.results"
                        :columns="fields"
                        :pagination="false"
                        :sticky-header="true"
                        height="100%"
                        :sortable="true"
                        skin="bh-table-compact"
                        row-class="routa-table-row"
                        cell-class="routa-table-cell"
                    >
                    </vue3-datatable>
                </div>
            </div>
            <hr/>
            <comment-container
                :topic="commentTopics.TOPIC_MVR_INSPECTION"
                :id="reportDetails.id"
                :user="user"
            />
            <hr/>
            <div class="col-12 d-flex justify-content-end">
                <button class="btn btn-secondary form-button" @click.stop="$emit('close')">{{$t('common.close')}}</button>
                <button class="btn btn-primary form-button" @click.stop="downloadPdf">{{$t('common.print')}}</button>
            </div>

        </div>
        <div v-if="loading" id="loader" class="spinner"></div>
    </div>
</template>

<script>
import {inspectionHelper} from '@/components//mixins/InspectionMixin'
import {timeUtils} from "@/components/mixins/TimeUtils";
import {PdfGeneratorManager} from "@/modules/PdfGeneratorManager";
import CommentContainer from "@/components/comments/CommentContainer.vue";
import {commentTopics} from "@/components/mixins/CommentMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {restApi} from "@/components/mixins/RestApiMixin";
import {pdfMixin} from "@/components/mixins/PdfMixin";

export default {
    name: 'MvrInspectionReportDetails',
    components: {CommentContainer, Vue3Datatable},
    mixins: [restApi, inspectionHelper, timeUtils, pdfMixin],
    props: {
        reportDetails: {
            type: Object,
            default: null
        },
        user: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            companyLogo: null,
            fields: [
                { field: 'inspectable', title: this.$t('mvr_inspection.inspection_report_details.inspectable'), sort: false, headerClass: 'routa-table-header'  },
                { field: 'pass_note', title: this.$t('mvr_inspection.inspection_report_details.pass'), sort: false, headerClass: 'routa-table-header'  },
                { field: 'pass', title: this.$t('mvr_inspection.inspection_report_details.total_short'), sort: false, headerClass: 'routa-table-header'  },
                { field: 'fail_note', title: this.$t('mvr_inspection.inspection_report_details.fail'), sort: false, headerClass: 'routa-table-header'  },
                { field: 'fails', title: this.$t('mvr_inspection.inspection_report_details.total_short'), sort: false, headerClass: 'routa-table-header'  }
            ],
        }
    },
    computed: {
        commentTopics() {
            return commentTopics
        },
    },
    methods: {

        getGroupedSections() {
            const groups = this.reportDetails.results.reduce((acc, item) => {
                const sectionId = item.section_group;

                // Find the section in the accumulator
                let sectionGroup = acc.find(sec => sec.section_group === sectionId);
                const sectionItem = {
                    fails: item.fails,
                    pass: item.pass,
                    pass_note: item.pass_note,
                    fail_note: item.fail_note,
                    inspectable: item.inspectable,
                };
                if(!sectionGroup) {
                    sectionGroup = {
                        section_group: sectionId,
                        section_header: item.section,
                        results: [sectionItem],
                    };
                    acc.push(sectionGroup);
                } else {
                    sectionGroup.results.push(sectionItem);
                }
                return acc;
            }, [])
            return groups
        },
        getTotal() {
            const total = {
                total_pass: 0,
                total_fails: 0,
                total_percentage: `${this.reportDetails.total}%`
            }
            this.reportDetails.results.forEach(item => {
                total.total_pass += item.pass
                total.total_fails += item.fails
            })
            return total
        },
        async downloadPdf() {
            this.loading = true
            const pdfBytes = await this.generatePdf()
            PdfGeneratorManager.downloadPdf(pdfBytes, `${this.$t('mvr_inspection.inspection_report_details.pdf_title')}`)
            this.loading = false
        },
        async generatePdf() {
            const {
                pdfDoc, pdfService, fonts, colors, footerLogo, companyFooterLogo, pdfGeneratorManager
            } = await this.initializePdf()

            const { fontText, fontHeader, fontBold } = fonts
            const { boldColor, textColor, headerColor } = colors

            let nextYPosition = undefined

            // Document title
            nextYPosition = pdfService.addText(pdfDoc, this.$t('mvr_inspection.inspection_report_details.report_title'), fontHeader, 20, nextYPosition, undefined, undefined, undefined, footerLogo, companyFooterLogo, headerColor)
            nextYPosition = pdfService.addText(pdfDoc, `${this.$t('mvr_inspection.inspection_report_details.date')}: ${this.getDate(this.reportDetails.created, true)}`, fontText, 12, nextYPosition, undefined, undefined, undefined, footerLogo, companyFooterLogo)
            nextYPosition = pdfService.addText(pdfDoc, `${this.$t('mvr_inspection.inspection_report_details.inspector')}: ${this.getInspector(this.reportDetails.inspector)}`, fontText, 10, nextYPosition, undefined, undefined, undefined, footerLogo, companyFooterLogo)
            nextYPosition = pdfService.addText(pdfDoc, `${this.$t('mvr_inspection.inspection_report_details.contract')}: ${this.reportDetails.contract.name}`, fontText, 10, nextYPosition, undefined, undefined, undefined, footerLogo, companyFooterLogo)
            nextYPosition = pdfService.addText(pdfDoc, `${this.$t('mvr_inspection.inspection_report_details.order')}: ${this.reportDetails.order ? this.reportDetails.order.task_type.name : "-"}`, fontText, 10, nextYPosition, undefined, undefined, undefined, footerLogo, companyFooterLogo)
            nextYPosition = pdfService.addText(pdfDoc, `${this.$t('mvr_inspection.inspection_report_details.site_notes')}: ${this.reportDetails.site || "-"}`, fontText, 10, nextYPosition, undefined, undefined, undefined, footerLogo, companyFooterLogo)
            nextYPosition -= 20

            // Total results
            let summary = this.getTotal()
            const totalResults = [
                [
                    this.$t('mvr_inspection.inspection_report_details.total_pass'),
                    this.$t('mvr_inspection.inspection_report_details.total_fail'),
                    this.$t('mvr_inspection.inspection_report_details.result'),
                ],
                [
                    summary.total_pass,
                    summary.total_fails,
                    summary.total_percentage
                ]
            ]
            nextYPosition = pdfService.addTable(totalResults, pdfDoc,
                { textFont: fontHeader, headerFont: fontText, textFontSize: 22, headerFontSize: 12, textColor: boldColor, headerFontColor: boldColor },
                nextYPosition, undefined, undefined, footerLogo, 1, 1, false, companyFooterLogo)

            nextYPosition -= 40
            // Measurement results
            for (const groupSection of this.getGroupedSections()) {
                const results = [
                    [
                        this.$t('mvr_inspection.inspection_report_details.inspectable'),
                        this.$t('mvr_inspection.inspection_report_details.pass'),
                        this.$t('mvr_inspection.inspection_report_details.total_short'),
                        this.$t('mvr_inspection.inspection_report_details.fail'),
                        this.$t('mvr_inspection.inspection_report_details.total_short'),
                    ],
                    ...groupSection.results.map(item => [
                        item.inspectable,
                        item.pass_note,
                        item.pass,
                        item.fail_note,
                        item.fails
                    ])
                ]
                nextYPosition = pdfService.addText(pdfDoc, `${groupSection.section_header}`, fontBold, 12, nextYPosition, undefined, undefined, undefined, footerLogo, companyFooterLogo, boldColor)
                nextYPosition = pdfService.addTable(results, pdfDoc, { textFont: fontText, headerFont: fontBold, textFontSize: 9, headerFontSize: 9, textColor: textColor, headerColor: boldColor },
                    nextYPosition, undefined, undefined, footerLogo, 1, 1, false, companyFooterLogo)
                nextYPosition -= 50
            }

            return await pdfGeneratorManager.generateBytesFromPdfDoc(pdfDoc)
        },
    }
}
</script>
